/* eslint-disable no-case-declarations */
import {
  UNDERLYING_LIVE_FEED,
  SUBSCRIBE_UNDERLYING_LIVE_FEED,
} from '../../constants/ActionTypes';
import {
  createFeedObjectFromConversionMap,
  updateLiveFeed,
  updateUnderlyingMap,
} from './updaters';

const underlyingLiveFeed = (
  state = {
    conversionMap: {},
    data: {},
    underlyingClosePrices: {},
    underlyingData: {},
  },
  action
) => {
  switch (action.type) {
    case UNDERLYING_LIVE_FEED:
      const { data: dataLiveFeed } = updateLiveFeed(state, action);

      return { ...state, data: dataLiveFeed };
    case SUBSCRIBE_UNDERLYING_LIVE_FEED:
      const { data: dataInitial, conversionMap: conversionMapInitial } =
        updateUnderlyingMap(state, action);

      const underlyingData = action.data?.underlyingData
        ? Object.fromEntries(
            Object.values(action.data?.underlyingData).map((item) => [
              item.name,
              item,
            ])
          )
        : {};

      const underlyingClosePricesData = createFeedObjectFromConversionMap(
        conversionMapInitial,
        action.data?.underlyingClosePrices
      );

      return {
        ...state,
        data: dataInitial,
        conversionMap: conversionMapInitial,
        underlyingClosePrices: underlyingClosePricesData,
        underlyingData,
      };
    default:
      return state;
  }
};

export default underlyingLiveFeed;
